import { render } from "./MediaContent.vue?vue&type=template&id=1ea9597e&scoped=true"
import script from "./MediaContent.vue?vue&type=script&lang=js"
export * from "./MediaContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea9597e"]])

export default __exports__